import React, { useState } from 'react'
import Modal from 'react-modal'
import _ from 'lodash'

import Slider from 'react-slick'

import PrevSilde from '../../assets/icons/arrow-left.svg'
import NextSlide from '../../assets/icons/arrow-right.svg'
import { htmlDecode } from '../../utilities/content/html'
import { onEnter } from '../../utilities/accessibility/onEnter'

import '../../styles/scss/components/slick.scss'
import '../../styles/scss/components/slick-theme.scss'
import '../../styles/scss/components/accommodation-modal.scss'

Modal.setAppElement('#ylg-ms__accommodations-modal')

// THIS COMPONENT WAS COPIED FROM THE YLG MS LISTINGS-DETAILS APP

const OtherInformation = ({ name, content }) => {
  return (
    <div className="other-information__wrapper">
      <div className="other-information__header">{name}</div>
      <div className="other-information__description">
        <div dangerouslySetInnerHTML={{ __html: htmlDecode(content) }} />
      </div>
    </div>
  )
}

const AccommodationDetail = ({ accommodation }) => {
  const [slider, setSlider] = useState()

  const renderArrows = () => {
    return (
      <div className="slider-arrow">
        <div
          className="arrow-btn prev"
          onClick={() => slider.slickPrev()}
          onKeyDown={event => onEnter(event, slider.slickPrev)}
          role="button"
          tabIndex="0"
        >
          <img src={PrevSilde} alt="previous-slide" />
        </div>
        <div
          className="arrow-btn next"
          onClick={() => slider.slickNext()}
          onKeyDown={event => onEnter(event, slider.slickNext)}
          role="button"
          tabIndex="0"
        >
          <img src={NextSlide} alt="next-slide" />
        </div>
      </div>
    )
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  const images = _.get(accommodation, 'images', [])

  const description = _.get(accommodation, 'description')
  const formattedDescription = _.includes(description, '&lt;p')
    ? htmlDecode(description)
    : description

  const includesOtherInformation = _.has(accommodation, 'address')
    || _.has(accommodation, 'general')
    || _.has(accommodation, 'valueAdd')
    || _.has(accommodation, 'dailyParking')

  return (
    <div className="accommodation-detail">
      <section className="accommodation-detail__title">
        <h4 aria-label={accommodation && accommodation.name}>
          About <span>{accommodation && accommodation.name}</span>
        </h4>
      </section>
      <section className="accommodation-detail__description">
        <p dangerouslySetInnerHTML={{ __html: formattedDescription }} />
      </section>
      {!_.isEmpty(images) && (
        <section className="accommodation-detail__slider">
          <Slider {...settings} className="accomodation-slider" ref={c => setSlider(c)}>
            {_.map(images, (image, index) => (
              <div key={`${index}`}>
                <img alt={_.get(image, 'description')} src={_.get(image, 'path')} />
              </div>
            ))}
          </Slider>
          {images.length > 1 && renderArrows()}
        </section>
      )}
      <section className="accommodation-detail__amenites-information">
        {_.get(accommodation, 'amenities') && (
          <div className="amenites">
            <h2 className="accommodation-detail__amenites-information__title" aria-label="Amenites">
              Amenities
            </h2>
            <div
              dangerouslySetInnerHTML={{
                __html: htmlDecode(accommodation.amenities[0])
              }}
            />
          </div>
        )}
        {includesOtherInformation && (
          <div className="other-information">
            <h2
              className="accommodation-detail__amenites-information__title"
              aria-label="Other Information"
            >
              Other Information
            </h2>
            {_.has(accommodation, 'address') && accommodation.address !== '' && (
              <OtherInformation name={'Address'} content={accommodation.address} />
            )}
            {_.has(accommodation, 'general') && accommodation.general !== '' && (
              <OtherInformation name={'General'} content={accommodation.general} />
            )}
            {_.has(accommodation, 'valueAdd') && accommodation.valueAdd !== '' && (
              <OtherInformation name={'Value Added'} content={accommodation.valueAdd} />
            )}
            {_.has(accommodation, 'dailyParking') && accommodation.dailyParking !== '' && (
              <OtherInformation name={'Daily Parking'} content={accommodation.dailyParking} />
            )}
          </div>
        )}
      </section>
    </div>
  )
}

const AccommodationModal = ({ accommodation, isOpen, onClose }) => (
  <Modal
    id="accommodation-modal"
    parentSelector={() => document.getElementById('ylg-ms__accommodations-modal')}
    contentLabel={_.get(accommodation, 'name')}
    isOpen={isOpen}
    onRequestClose={onClose}
  >
    <div
      className="modal-close"
      role="button"
      onClick={onClose}
      onKeyDown={event => onEnter(event, onClose)}
      tabIndex="0"
    />
    <div className="u-full-width accommodation-modal">
      <AccommodationDetail accommodation={accommodation} />
    </div>
  </Modal>
)

export default AccommodationModal
